import TitleDisplayField from "../atom/TitleDisplayField";
import DescDisplayField from "../atom/DescDisplayField";
import DisplayModeButtons from "../molecules/DisplayModeButtons";

const HistoryDetailDisplay = ({ item, closeModal, closeSubModal, subModalMount, formData, toggleEditModeHandler, handleLoadDesign, handleDeleteHistory, date }) => {
  const deviceType = sessionStorage.getItem("deviceType");
  const {title, description} = formData;
  const modalProps = { closeModal, closeSubModal, subModalMount };


  return (
    <>
      <div className={"detail-design-history-body"}>
        <div className={"detail-design-history-inner"}>
          <div className={"detail-design-history-images"}>
            <div className={"screenshot"}>
              <img src={item.extImage} alt={"Vehicle Exterior Image"}/>
            </div>
            <div className={"screenshot"}>
              <img src={item.intImage} alt={"Vehicle Interior Image"}/>
            </div>
          </div>
          <div className={"detail-design-history-contents"}>
            <div className={"detail-design-history-date"}>
              <span>{ date }</span>
            </div>
            <TitleDisplayField toggleEditModeHandler={toggleEditModeHandler} title={title}/>
            {
              deviceType === "mobile" && (
                <DisplayModeButtons {...modalProps} handleLoadDesign={() => handleLoadDesign(closeModal, closeSubModal)}/>
              )
            }
            <DescDisplayField description={description}/>

          </div>
        </div>
      </div>
      <div className={"detail-design-history-footer"}>
        {
          deviceType === "desktop" && (
            <div className={"detail-design-history-inner"}>
              <div className={"detail-design-history-footer-buttons"}>
                <DisplayModeButtons {...modalProps} handleDeleteHistory={handleDeleteHistory} handleLoadDesign={() => handleLoadDesign(closeModal, closeSubModal)} />
              </div>
            </div>
          )
        }
      </div>
    </>
  )
}

export default HistoryDetailDisplay;
